import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a68ce93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "warning-point-container" }
const _hoisted_2 = { class: "text-container" }

import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

interface ChatSettingsWarningPointProps {
  title: string;
  text: string;
  iconName: IconType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSettingsWarningPoint',
  props: {
    title: {},
    text: {},
    iconName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      icon: _ctx.iconName,
      class: "warning-point-icon",
      alt: _ctx.iconName.toLowerCase()
    }, null, 8, ["icon", "alt"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t(_ctx.title)), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t(_ctx.text)), 1)
    ])
  ]))
}
}

})